/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTipoIdentificacionVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaTipoIdentificacion: React.FunctionComponent<ITablaTipoIdentificacionVistaProps & InjectedIntlProps> = ({
    tipoIdentificacions,
    cargarTipoIdentificacion,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tipoIdentificacions}
            actions={acciones(manejarFormulario, cargarTipoIdentificacion, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaTipoIdentificacion);
